import { motion } from "framer-motion";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import PublicLayout from "@/components/layout/PublicLayout";
import { COMPANY, whatsappLink } from "@/config/company";

const cards = [
  { icon: Phone, title: "Call us", lines: [COMPANY.phone] },
  { icon: MessageCircle, title: "WhatsApp", lines: [COMPANY.whatsappDisplay] },
  { icon: Mail, title: "Email us", lines: [COMPANY.email] },
  {
    icon: MapPin, title: "Registered office",
    lines: [COMPANY.legalName, ...COMPANY.addressLines, `CIN: ${COMPANY.cin}`, `GSTIN: ${COMPANY.gstin}`],
  },
  {
    icon: MapPin, title: "Sendtoo – Bharat CourierPoint",
    lines: ["49-34-8, Akkayyapalem Main Road", "opp. Coastal Bank, NGGO Colony", "Akkayyapalem, Visakhapatnam – 530016, AP"],
  },
];

export default function Contact() {
  return (
    <PublicLayout>
      <div className="min-h-screen">
        {/* Hero */}
        <div className="bg-gradient-to-br from-[#0A183D] to-[#1B3FA0] py-20">
          <div className="max-w-2xl mx-auto px-4 text-center">
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white">Get in touch</h1>
            <p className="text-blue-200 mt-4 text-lg">The fastest way to reach us is WhatsApp — we're usually quick to respond.</p>
            <a
              href={whatsappLink("Hi Sendtoo")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-hero-btn"
              className="inline-flex items-center gap-2 px-7 py-3 bg-[#25D366] text-white font-semibold rounded-sm hover:bg-[#1FBE5A] transition-colors mt-7"
            >
              <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
            </a>
          </div>
        </div>

        {/* Contact cards */}
        <section className="py-20 bg-slate-50">
          <div className="max-w-4xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {cards.map((c, i) => (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.08 }}
                viewport={{ once: true }}
                className="bg-white p-6 rounded-lg flex gap-4"
              >
                <c.icon className="w-5 h-5 text-brand-500 shrink-0 mt-0.5" strokeWidth={1.5} />
                <div>
                  <h4 className="font-heading font-semibold text-slate-900 mb-1.5">{c.title}</h4>
                  {c.lines.map((line, j) => (
                    <p key={j} className="text-sm text-slate-600">{line}</p>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </section>
      </div>
    </PublicLayout>
  );
}
